package com.macrofocus.nastac.ui.layer

import com.macrofocus.nastac.ui.hexToRgba
import deckgl.GeoJsonLayer
import js.objects.unsafeJso

fun createGeopoliticsKinLayer(visible: Boolean, year: Int) : GeoJsonLayer {
    val orRd = listOf(
        hexToRgba("#FFF7EC"), hexToRgba("#FEE8C8"), hexToRgba("#FDD49E"), hexToRgba("#FDBB84"), hexToRgba("#FC8D59"),
        hexToRgba("#EF6548"), hexToRgba("#D7301F"), hexToRgba("#B30000"), hexToRgba("#7F0000"), hexToRgba("#FF0000")
    )

    val geopoliticsLayer = GeoJsonLayer(unsafeJso {
        id = "geopoliticsKin-$year"

        this.visible = visible

        this.data = "/RiskMap-2023.geojson"

        this.pickable = true
        opacity = 0.7
        asDynamic().stroked = true
        asDynamic().filled = true
        asDynamic().extruded = false
        asDynamic().pointType = "circle"
//        lineWidthScale = 20
        asDynamic().lineWidthMinPixels = 2
        asDynamic().lineWidthMaxPixels = 4
        asDynamic().getFillColor = { d : dynamic ->
            val lexclpop = (d.properties.excl_tek_main_lsize as? Number)?.toDouble()
            if(lexclpop == null) orRd[0]
            else if(lexclpop >= 1.0) orRd[9]
            else if(lexclpop >= 0.5) orRd[8]
            else if(lexclpop >= 0.25) orRd[6]
            else if(lexclpop >= 0.1) orRd[4]
            else if(lexclpop > 0.0) orRd[2]
            else orRd[1]
        }
        asDynamic().getLineColor = arrayOf(0, 0, 0, 200)
        asDynamic().getPointRadius = 100
        asDynamic().getLineWidth = 5000
        asDynamic().getElevation = 30

//        onOver = { info: dynamic ->
//            println("onOver: $info")
//        }
    })

    return geopoliticsLayer;
}